import {
  getFacility,
  createFacility,
  updateFacility,
  deleteFacility,
  getCondensedFacilityList,
} from "@ckweb/ckfetch/connectables/setup";
import { getCleaningRoles } from "@ckweb/ckfetch/connectables/cleaning";
import { getSkillList } from "@ckweb/ckfetch/connectables/employeeManagement";
import { getDefaultProductCategories } from "@ckweb/ckfetch/connectables/productManagement";
import { getCorporateCategoryList } from "@ckweb/ckfetch/connectables/equipmentAreaManagement";
import { uploadFileToBlob } from "@ckweb/ckfetch/connectables/import";

export const useGetFacility = () =>
  useSafeLocalFetch(`getFacility`, getFacility, {
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    mapError: "cksetup.facilities.failedToFetchFacility",
  });

export const useGetFacilityList = () =>
  useSafeLocalFetch(`getCondensedFacilityList`, getCondensedFacilityList, {
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    mapError: "cksetup.facilities.failedToFetchFacilities",
  });

export const useCreateFacility = () =>
  useSafeLocalFetch(`createFacility`, createFacility, {
    fetchType: "mutate",
    mapError: "cksetup.wizard.failedToCreateFacility",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });

export const useUpdateFacility = () =>
  useSafeLocalFetch(`updateFacility`, updateFacility, {
    fetchType: "mutate",
    mapError: "cksetup.wizard.failedToUpdateFacility",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });

export const useDeleteFacility = () =>
  useSafeLocalFetch(`deleteFacility`, deleteFacility, {
    fetchType: "mutate",
  });

export const useGetCleaningRoleOptions = () =>
  useSafeLocalFetch("getCleaningRoles", getCleaningRoles, {
    mapError: "cksetup.wizard.failedToFetchCleaningRoles",
  });

export const useGetDefaultSkillList = () =>
  useSafeLocalFetch(`fetchSkillList`, getSkillList, {
    customFetchOpts: customFetchOptsForPlantIdDefaults(),
    fallback: [],
  });

export const useGetProductCategories = () =>
  useSafeLocalFetch("getProductCategories", getDefaultProductCategories, {
    mapError: "cksetup.wizard.failedToFetchProductCategories",
    showGlobalLoadingIndicator: true,
  });

export const useGetDefaultCorporateKpis = () =>
  useSafeLocalFetch(
    `getDefaultCorporateCategoryList`,
    getCorporateCategoryList,
    {
      customFetchOpts: customFetchOptsForPlantIdDefaults(),
      fallback: [],
      showGlobalLoadingIndicator: true,
    },
  );

export const useUploadImportFile = () =>
  useSafeLocalFetch("uploadFileToBlob", uploadFileToBlob, {
    fetchType: "mutate",
  });
